export default "__VITE_ASSET__DrFfiAyV__"